var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.Links && _vm.Links.length>0)?_c('div',{staticClass:"flex-row start middle"},_vm._l((_vm.Links),function(url,index){return _c('el-image',{key:index,style:(_vm.Style),attrs:{"src":url,"preview-src-list":_vm.Links,"fit":"cover"}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }